module.exports = __webpack_public_path__ + "img/violet_098.021a8f13.png";